import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Loader } from '../../../_components';
import { history } from '../../../_helpers';
import { momentumActions } from '../../../_actions';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import queryString from 'query-string';

import './Listing.momentum.scss';

class RegisterMomentumContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      momentums: [],
      domain: JSON.parse(sessionStorage.getItem('selected_domain')).uuid,
      changedDomain: '',
      updating: true,
      modified: false,
      deletedMomentums: {},
      activeMomentums: {},
      scheduledMomentums: {},
      pausedMomentums: {},
      draftMomentums: {},
      deletedMomentumsCount: 0,
      activeMomentumsCount: 0,
      scheduledMomentumsCount: 0,
      pausedMomentumsCount: 0,
      draftMomentumsCount: 0,
      diagramPath: "/v1/momentum/create",
      mainPath: "/v1/momentums"
    }

    this.editCard = this.editCard.bind(this);
    this.deleteCard = this.deleteCard.bind(this);
    this.pauseOrStart = this.pauseOrStart.bind(this);
    this.updateListing = this.updateListing.bind(this);
    this.viewMomentum = this.viewMomentum.bind(this);
  }

  listMomentums(type) {  
    if ( type ) {
      return this.setState({
        momentums: this.state[`${type}Momentums`]
      })
    }

    const { dispatch } = this.props;

    if ( history.location.pathname === "/campaigns" ) {
      this.setState({diagramPath: "/campaign/create", mainPath: "/campaigns"});
    }

    dispatch(momentumActions.listMomentums(queryString.parse(this.props.location.search).domain))
      .then(res => {
        if ( !res.data ) return this.setState({updating: false});

        let data = res.data.data;

        let activeMomentums = data.filter(m => m.status === "Active");
        let scheduledMomentums = data.filter(m => m.status === "Paused" && m.scheduled_at && m.scheduled_at.length !== 0);
        let pausedMomentums = data.filter(m => m.status === "Paused" && !m.scheduled_at);
        let draftMomentums = data.filter(m => m.status === "Draft");
        let deletedMomentums = data.filter(m => m.status === "Deleted");

        if ( history.location.pathname === "/campaigns" ) {
          activeMomentums = activeMomentums.filter(m => m.type === "campaign");
          scheduledMomentums = scheduledMomentums.filter(m => m.type === "campaign");
          pausedMomentums = pausedMomentums.filter(m => m.type === "campaign");
          draftMomentums = draftMomentums.filter(m => m.type === "campaign");
          deletedMomentums = deletedMomentums.filter(m => m.type === "campaign");
        } else {
          activeMomentums = activeMomentums.filter(m => m.type !== "campaign" || !m.type);
          scheduledMomentums = scheduledMomentums.filter(m => m.type !== "campaign" || !m.type);
          pausedMomentums = pausedMomentums.filter(m => m.type !== "campaign" || !m.type);
          draftMomentums = draftMomentums.filter(m => m.type !== "campaign" || !m.type);
          deletedMomentums = deletedMomentums.filter(m => m.type !== "campaign" || !m.type);
        }

        if ( type ) return this.setState({momentums: [`${type}Momentums`]});

        this.setState({
          momentums: activeMomentums,
          activeMomentums: activeMomentums,
          scheduledMomentums: scheduledMomentums,
          pausedMomentums: pausedMomentums,
          draftMomentums: draftMomentums,
          deletedMomentums: deletedMomentums,
          activeMomentumsCount: activeMomentums.length,
          scheduledMomentumsCount: scheduledMomentums.length,
          pausedMomentumsCount: pausedMomentums.length,
          draftMomentumsCount: draftMomentums.length,
          deletedMomentumsCount: deletedMomentums.length,
          updating: false
        });
      });
  }

  componentWillMount() {
    document.title = "Momentums - Cellit.io";

    if ( history.location.pathname === "/campaigns" ) {
      document.title = "Campanhas - Cellit.io";
    }

    setTimeout(() => {
      let domain = queryString.parse(this.props.location.search).domain;
      if ( !domain ) return history.push('/');
    }, 50);

    this.listMomentums();
  }

  componentDidMount() {
    if ( history.location.state !== "ACTIVE_DOMAIN_NOT_EDITABLE" ) return;

    toast.error("Não é permitido editar Momentums em andamento.", {
      position: toast.POSITION.TOP_RIGHT,
      className: 'toast-error'
    });
  }

  async componentWillReceiveProps() {
    if ( !history.location.search ) return;

    await this.setState({
      changedDomain: queryString.parse(history.location.search).domain,
      momentums: [],
      updating: true
    })
    
    this.listMomentums();
  }

  editCard(e) {
    let uuid = e.target.getAttribute('data-uuid');
    history.push(`${this.state.diagramPath}?domain=${this.state.domain}&uuid=${uuid}`)
  }

  viewMomentum(e) {
    let uuid = e.target.getAttribute('data-uuid');
    history.push(`${this.state.diagramPath}?domain=${this.state.domain}&uuid=${uuid}&mode=view`)
  }

  deleteCard(e) {
    const { dispatch } = this.props;

    this.setState({updating: true});

    let uuid = e.target.getAttribute('data-uuid');
    let momentum = e.target.getAttribute('data-momentum');

    dispatch(momentumActions.softDeleteMomentum(uuid, this.state.domain, momentum))
      .then(res => {
        if ( res.type === "REMOVE_MOMENTUM_FAILURE" ) {
          this.setState({updating: false});
          return toast.error("Não foi possível remover o momentum. Tente novamente mais tarde.", {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-error'
          })
        }

        this.listMomentums();

        toast.success("Seu momentum foi removido com sucesso!", {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-success'
        });
      })
  }

  pauseOrStart(e) {
    e.preventDefault();

    const { dispatch } = this.props;

    let data = e.target.getAttribute('data-momentum');
    let type = e.target.getAttribute('data-type');

    this.setState({updating: true});

    dispatch(momentumActions.updateMomentumStatus(data, type, this.state.domain))
      .then(res => {
        if ( res.error ) return;

        this.listMomentums();
      })
  }

  updateListing(e) {
    let type = e.target.getAttribute('data-list-type');
    this.listMomentums(type);
  }

  render() {
    return (
      <>
        <section key={this.state.changedDomain} className="component component-listing-momentums">
          <div className="component-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <h1 className="title">
                    {
                      history.location.pathname === "/campaigns" ?
                        "Campanhas"
                      : "Momentums"
                    }
                  </h1>
                </div>
                <div className="col-3">
                  <Link to={this.state.diagramPath+'?domain='+this.state.domain} className="btn btn-white btn-add-momentum float-right">
                    <i className="linearicons-plus-circle"></i>
                    Criar momentum
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="component-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <div className="status-selector">
                    <button onClick={this.updateListing} data-list-type="active">Ativos ({this.state.activeMomentumsCount})</button>|
                    <button onClick={this.updateListing} data-list-type="scheduled">Agendados ({this.state.scheduledMomentumsCount})</button>|
                    <button onClick={this.updateListing} data-list-type="paused">Pausado ({this.state.pausedMomentumsCount})</button>|
                    <button onClick={this.updateListing} data-list-type="draft">Rascunho ({this.state.draftMomentumsCount})</button>|
                    <button onClick={this.updateListing} data-list-type="deleted">Removidos ({this.state.deletedMomentumsCount})</button>
                  </div>
                </div>
              </div>

              <div className="row">
                {
                  !this.state.updating ?
                    <Table data={this.state.momentums} evt={this} />
                  : <Loader />
                }
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}

class Table extends Component {
  render() {
    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Título</th>
              <th>Descrição</th>
              <th>Status</th>
              <th>Canal selecionado</th>
              <th>Data de Agendamento</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Opções</th>
            </tr>
          </thead>
          <tbody ref={this.tbody}>
            {
              this.props.data && this.props.data.length !== 0 ?
                this.props.data.map((momentum, index) => {
                  return <tr key={momentum.uuid}>
                    <td>{index + 1}</td>
                    <td>{momentum.momentum_title}</td>
                    <td>{momentum.momentum_description}</td>
                    <td>
                    {
                      momentum.status === "Paused" && !momentum.scheduled_at ? 
                        "Pausado"
                      : momentum.status === "Active" ?
                        "Ativo"
                      : momentum.status === "Deleted" ?
                        "Removido"
                      : momentum.status === "Draft" ?
                        "Rascunho"
                      : momentum.status === "Paused" && momentum.scheduled_at ?
                        "Agendado"
                      : null
                    }
                    </td>
                    <td>
                      {
                        momentum.channels.channel_type === "SUPERARE_NOTIFICATION" ?
                          "Superare"
                        : momentum.channels.channel_type === "ZENVIA" ?
                          "Zenvia"
                        : momentum.channels.channel_type === "AWS_SES" ?
                          "AWS"
                        : momentum.channels.channel_type === "AKNA" ?
                          "Akna"
                        : momentum.channels.channel_type === "ONE_SIGNAL" ?
                          "One Signal"
                        : momentum.channels.channel_type === "SUPERARE_WEBVIEW" ?
                          "Webview"
                        : null
                      }
                    </td>
                    <td>
                      {
                        momentum.status !== "Active" && momentum.scheduled_at ?
                          <span className="schedule-text">
                            <span>{moment(momentum.scheduled_at).format('DD/MM/YYYY') + ' às ' + moment(momentum.scheduled_at).utcOffset('+0000').format('HH:mm')}</span>

                            {
                              moment(momentum.scheduled_at).diff(moment(), 'days', 'hours') >= 0 ?
                                <strong>
                                  {
                                    moment(momentum.scheduled_at).diff(moment(), 'days') === 0 ?
                                      'HOJE!'
                                    : moment(momentum.scheduled_at).diff(moment(), 'days')+'d'
                                  }
                                </strong>
                              : <strong className="bg-green">
                                <i className="linearicons-check"></i>
                              </strong>
                            }
                          </span>
                        : null
                      }
                    </td>
                    <td>{moment(momentum.created_at).format('DD/MM/YYYY')}</td>
                    <td>{moment(momentum.updated_at).format('DD/MM/YYYY')}</td>
                    <td>
                      <div className="button-group">
                        {
                          momentum.status === "Active" ?
                            <button className="btn btn-orange btn-icon" onClick={this.props.evt.pauseOrStart} data-type="pause" data-momentum={JSON.stringify(momentum)} title="Pausar">
                              <i className="linearicons-pause-circle"></i>
                            </button>
                          : null
                        }
                        {
                          momentum.status === "Paused" ?
                            <button className="btn btn-green btn-icon" onClick={this.props.evt.pauseOrStart} data-type="start" data-momentum={JSON.stringify(momentum)} title="Iniciar">
                              <i className="linearicons-play-circle"></i>
                            </button>
                          : null
                        }
                        {
                          momentum.status === "Active" || (momentum.status === "Paused" && !momentum.scheduled_at) ?
                            <button className="btn btn-white btn-icon" onClick={this.props.evt.viewMomentum} data-uuid={momentum.uuid} data-momentum={JSON.stringify(momentum)} title="Visualizar"><i className="linearicons-eye"></i></button>
                          : null
                        }
                        {
                          momentum.status !== "Deleted" ?
                            <>
                              <button className="btn btn-blue btn-icon" onClick={this.props.evt.editCard} data-uuid={momentum.uuid} title="Editar"><i className="linearicons-pencil"></i></button>
                              <button className="btn btn-red btn-icon" onClick={this.props.evt.deleteCard} data-uuid={momentum.uuid} data-momentum={momentum.uuid} title="Remover"><i className="linearicons-trash2"></i></button>
                            </>
                          : null
                        }
                      </div>
                    </td>
                  </tr>
                }) : null
            }
          </tbody>
        </table>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { listingMomentums } = state.listMomentumsReducer;
  return listingMomentums;
}

const ConnectedRegisterMomentumContainer = connect(mapStateToProps)(RegisterMomentumContainer);
export { ConnectedRegisterMomentumContainer as RegisterMomentumContainer }